export function objTxt() {
  
  jQuery(function () {


     var $win = $(window);
  var $A = $('.c-pageObjTxtWrap');
  var $B = $('.c-pageObjTxt');
  var $C = $('.l-header_logo');

  if (!$A.length || !$B.length || !$C.length) return;

  var C_height = $C.outerHeight();
  var B_height = $B.outerHeight();
  var E = C_height + B_height;
  
  // load時のみ固定値取得（更新しない）
  var B_top = $B.offset().top;

  function updateSizes() {
    C_height = $C.outerHeight();
    B_height = $B.outerHeight();
    E = C_height + B_height;
    // B_topは更新しない
  }
  $win.on('resize', updateSizes);
  updateSizes();

  function toggleClasses() {
    var scrollTop = $win.scrollTop();
    
    var D_threshold = B_top - C_height; // load時のB_top使用
    
    var A_bottom = $A.offset().top + $A.outerHeight();
    var F_threshold = A_bottom - E;

    // ① D通過 → is-fixed付与 + top: C_height
    if (scrollTop >= D_threshold && !$B.hasClass('is-fixed')) {
      $B.addClass('is-fixed').removeClass('is-bottom')
         .css('top', C_height + 'px');
    }
    // D通過条件外 → is-fixed解除 + topリセット
    else if (scrollTop < D_threshold && $B.hasClass('is-fixed')) {
      $B.removeClass('is-fixed is-bottom')
         .css('top', '');
    }

    // ② F通過 → is-bottom付与 + topリセット
    if (scrollTop >= F_threshold && $B.hasClass('is-fixed')) {
      $B.removeClass('is-fixed').addClass('is-bottom')
         .css('top', '');
    }
  }

  $win.on('load scroll resize', toggleClasses);

  });//jQuery

}